/** Leads to Onboarding Creative page */
export enum getOnboardingCTLinks {
  EN = 'https://backboneart.typeform.com/to/dRDnNUk1?typeform-source=bkbn.com',
  DE = 'https://backboneart.typeform.com/to/c8lLocL4?typeform-source=bkbn.com',
  FR = 'https://backboneart.typeform.com/to/A8PfKd4u',
  NL = 'https://backboneart.typeform.com/to/eCRJ6Rpg?typeform-source=bkbn.com',
}
